module.exports = __webpack_public_path__ + "static/media/app-shell.bb7e2b11.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/step-3/app-shell.png
 ** module id = 353
 ** module chunks = 0
 **/